import { makeOrderedListComparitor } from "../../utils/sort";
import { MembershipRole } from "./Team";
import { EDITION_ORDER } from "./Team.consts";

export const reclaimEditionComparitor = makeOrderedListComparitor(EDITION_ORDER);
export const membershipRoleComparitor = makeOrderedListComparitor([MembershipRole.Admin, MembershipRole.User]);
